export default __webpack_public_path__ + "1b39337063618aa45c74cd3b96f50ca1.png";